// Saludo diario de Sina: hora del día, nombre y, si hay datos, el trabajo pendiente real.

export const FRIENDLY_GREETINGS = Object.freeze([
  'Acá estoy para ayudarte. Si algo se traba, tocame y lo vemos juntos.',
  'Arrancamos. Si querés rastrear una guía o una foja, pedímela.',
  'Mate en mano y a romperla. Estoy acá si me necesitás.',
  'Todo tranquilo por ahora. Que sea un buen día de trabajo.',
  'Hoy también salen los camiones a horario. Contá conmigo.',
]);

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const pad = (value) => String(value).padStart(2, '0');

const localDayKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const localDayIndex = (date) => Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY);

const plural = (count, singular, pluralForm) => `${count} ${count === 1 ? singular : pluralForm}`;

const joinWithY = (items) => (items.length > 1 ? `${items.slice(0, -1).join(', ')} y ${items[items.length - 1]}` : items[0] || '');

export function getSalutation(now = new Date()) {
  const hour = now.getHours();
  if (hour >= 5 && hour < 13) return 'Buen día';
  if (hour >= 13 && hour < 20) return 'Buenas tardes';
  return 'Buenas noches';
}

export function getFirstName(user) {
  return String(user?.nombre || '').trim().split(/\s+/)[0] || '';
}

export function buildPendingHighlights(dashboard, limit = 2) {
  if (!dashboard) return [];
  const retirosVencidos = Number(dashboard.retiros?.vencidos) || 0;
  const fojasSinSalida = Array.isArray(dashboard.fojasSinSalida) ? dashboard.fojasSinSalida.length : 0;
  const porRecibir = Number(dashboard.kpis?.porRecibir?.guias) || 0;
  const colaReparto = Number(dashboard.entregas?.colaReparto?.guias) || 0;

  return [
    retirosVencidos > 0 ? plural(retirosVencidos, 'retiro vencido', 'retiros vencidos') : null,
    fojasSinSalida > 0 ? plural(fojasSinSalida, 'foja sin salida', 'fojas sin salida') : null,
    porRecibir > 0 ? plural(porRecibir, 'guía por recibir', 'guías por recibir') : null,
    colaReparto > 0 ? plural(colaReparto, 'guía esperando reparto', 'guías esperando reparto') : null,
  ].filter(Boolean).slice(0, limit);
}

export function buildSinaGreeting({ now = new Date(), user, highlights = [] }) {
  const name = getFirstName(user);
  const title = `¡${getSalutation(now)}${name ? `, ${name}` : ''}!`;
  const message = highlights.length
    ? `Hoy tenés ${joinWithY(highlights)}. Si querés, te ayudo a encararlo.`
    : FRIENDLY_GREETINGS[localDayIndex(now) % FRIENDLY_GREETINGS.length];
  return { title, message };
}

export function greetingStamp(userKey, now = new Date()) {
  return `${userKey}:${localDayKey(now)}`;
}

export function shouldGreet(storedStamp, userKey, now = new Date()) {
  return storedStamp !== greetingStamp(userKey, now);
}
